import { AxiosInstance } from "axios";
import { ApiRouteHelpers as Helpers } from "../../../root/apiRoutes";
import {
  OrganizationPublicId,
  PortalSessionResponse,
  ChargebeeCustomerInfoResponse,
} from "../Types";

export class ChargebeeSessionController {
  constructor(private axios: AxiosInstance) {}

  /**
   * Creates a Chargebee portal session for the specified organization.
   * @param organizationId The public ID of this organization.
   * @returns A promise resolving to the portal session response.
   */
  public createPortalSession = async (
    organizationId: OrganizationPublicId,
  ): Promise<PortalSessionResponse> => {
    const accessUrl = Helpers.organization.createChargebeePortal(organizationId);
    const response = await this.axios.post<PortalSessionResponse>(accessUrl);

    return response.data;
  };

  /**
   * Fetches customer email and subscription info from Chargebee.
   * @param organizationId The public ID of this organization.
   * @returns A promise resolving to the customer information response.
   */
  public getCustomerInfo = async (
    organizationId: OrganizationPublicId,
  ): Promise<ChargebeeCustomerInfoResponse> => {
    const url = Helpers.organization.getChargebeeCustomerInfo(organizationId);
    const response = await this.axios.get<ChargebeeCustomerInfoResponse>(url);
    return response.data;
  };
}
